import request from '@/plugins/axios'

/** S 商城列表 **/
// 结算单列表
export const apiSettleLists = (params: any) => request.get('/scrm.settlement/list', { params })

// 查看结算单
export const apiSettleView = (params: any) => request.get('/scrm.settlement/info', { params })

// 导出结算单
export const apiSettleExport = (params: any) => request.get('/scrm.settlement/orderExport', { params })
// 驳回
export const apiSettleReject = (data: any) => request.put('/scrm.settlement/reject', data)

// 提交结算打款凭证
export const apiSettleVouncher = (data: any) => request.put('/scrm.settlement/voucher', data)

// 确认服务费打款成功

export const apiSettleConfirmServiceFee = (data: any) => request.put('/scrm.settlement/confirmServiceFee', data)
